import { ParsedUrlQuery } from 'querystring';

export function getIncludeSharedAccommodation(query: ParsedUrlQuery) {
    if (query['include_shared_accommodation']) {
        return query['include_shared_accommodation'];
    }

    return '';
}
